module.exports = __webpack_public_path__ + "img/healthcare_icon.b60da34e.svg";